import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import AdminLogin from "./AdminLogin";
import AdminPanel from "./AdminPanel";

export default function AdminApp() {
  const [authed, setAuthed] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("ktn_admin_token");
    if (!token) {
      setChecking(false);
      return;
    }
    api
      .get("/auth/me")
      .then(() => setAuthed(true))
      .catch(() => localStorage.removeItem("ktn_admin_token"))
      .finally(() => setChecking(false));
  }, []);

  if (checking) {
    return (
      <div className="min-h-screen bg-charcoal flex items-center justify-center" data-testid="admin-loading">
        <img src="/logo.png" alt="Kannur TheyyamNow" className="w-24 h-auto animate-pulse" />
      </div>
    );
  }

  return authed ? <AdminPanel onLogout={() => setAuthed(false)} /> : <AdminLogin onLogin={() => setAuthed(true)} />;
}
